import { TokenManager } from './token-manager';

export const performLogout = async (reason: 'manual' | 'inactivity' = 'manual'): Promise<void> => {
    console.log('Starting logout...');

    const tokenManager = TokenManager.getInstance();

    try {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/api/saml/logout`,
            {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    } catch (error) {
        console.error('Logout API call failed:', error);
    } finally {
        // Always clear local state regardless of API success
        tokenManager.clearToken();

        // Redirect to logged-out page
        if (reason === 'inactivity') {
            window.location.href = '/logged-out?reason=inactivity';
        } else {
            window.location.href = '/logged-out';
        }
    }
};